// per-method imports: 'lodash/fp' pulls the whole of lodash into the brief pack
import capitalize from 'lodash/capitalize';
import isArray from 'lodash/isArray';
import { isZipValid } from '../utils/validation';

export const gettingStartedSelector = state => {
  const {
    rooms: planRooms,
    services,
    family,
    address,
    proPlatform,
    plans_list: plansOptions,
    prices,
    roomsOptions,
    roomsParams,
    packages,
    packages_list: packagesOptions,
    newCustomer,
  } = state.gettingStarted;
  // const familyAdults = Object.values(family.adults);
  // const familyAdultsInvalid = familyAdults.some(adult => !adult.gender || !adult.age);
  // const familyChildren = Object.values(family.children);
  // const familyChildrenInvalid = familyChildren.some(child => !child.gender || !child.age);
  // const familyPets = Object.values(family.pets);
  // const familyPetsInvalid = familyPets.some(
  //   pet => !pet.type || (pet.type === 'other' && !pet.name),
  // );
  // const noFamilyMembers = !familyAdults.length && !familyChildren.length && !familyPets.length;
  // const noFamilyMembers = false;
  // const familyInvalid = familyAdultsInvalid || familyChildrenInvalid || familyPetsInvalid || noFamilyMembers

  const addressInvalid =
    Object.values(address).some(value => !(value || '').trim().length) ||
    !isZipValid(address.postcode);
    // !isPhoneValid(address.phone) ||

  const rooms = isArray(planRooms)
    ? planRooms
    : Object.keys(planRooms).map(p => ({ type: p, quantity: +planRooms[p] }));

  const rooms2 = rooms.reduce((acct, roomEntity) => {
    const items = Array.from(Array(roomEntity.quantity));
    return [
      ...acct,
      ...items.map((_, idx) => ({
        name: `${roomEntity.type}_${idx + 1}`,
        key: roomEntity.type,
        index: idx,
        multipleOfSameType: roomEntity.quantity > 1,
      })),
    ];
  }, []);

  // debugger;

  const roomDeliveryOptionLabel = (room, key, multipleOfSameType, index) => {
    const res =
    roomsParams[key]
      ? `${roomsParams[key].label}${multipleOfSameType ? ` ${index + 1}` : ''}`
      : room.split('_').map(capitalize).join(' ');
    return res;
  };


  const roomsDeliveryOptions = rooms2.map(({ name: room, key, index, multipleOfSameType }) => {
    const res = {
      name: key,
      value: room,
      label: roomDeliveryOptionLabel(room, key, multipleOfSameType, index),
      selected: packages[room] && packages[room].term,
      icon: roomsParams[key] && roomsParams[key].icon,
      index,
    };
    return res;
  });

  // const packageInvalid = rooms.some(
  //   ({ name: room }) => !packages[room] || (packages[room] && !packages[room].plan),
  // );
  const deliveryInvalid = rooms.some(
    ({ name: room }) => !packages[room] || (packages[room] && !packages[room].term),
  );


  return {
    roomsDelivery: roomsDeliveryOptions,
    packagesOptions: packagesOptions || [],
    roomsParams: roomsParams || {},
    roomsOptions: roomsOptions || [],
    plansOptions: plansOptions || [],
    newCustomer,
    prices,
    values: {
      rooms,
      address,
      packages,
    },
    form: {
      roomsInvalid: !rooms.length,
      addressInvalid,
      // packageInvalid,
      deliveryInvalid,
    },
    proPlatform,
  };
};

// export const gettingStartedPlanSelector = state => {
//   const {
//     rooms: planRooms,
//     packages,
//     prices,
//     address,
//     roomsOptions,
//     packages_list: packagesOptions,
//     plans_list: plansOptions,
//   } = state.gettingStartedPlan;
//
//   const rooms = Object.keys(planRooms).reduce((acct, key) => {
//     const items = Array.from(Array(+planRooms[key]).keys());
//     return [
//       ...acct,
//       ...items.map((_, idx) => ({
//         name: `${key}_${idx + 1}`,
//         key,
//         index: idx,
//         multipleOfSameType: items.length > 1,
//       })),
//     ];
//   }, []);
//   const roomsValues = isArray(planRooms)
//     ? planRooms
//     : Object.keys(planRooms).map(p => ({ type: p, quantity: +planRooms[p] }));
//
//   const roomsPackagesOptions = rooms.map(({ name: room, key, index, multipleOfSameType }) => ({
//     name: key,
//     value: room,
//     label: roomsOptions[key]
//       ? capitalize(`${roomsOptions[key].label}${multipleOfSameType ? ` ${index + 1}` : ''}`)
//       : room
//           .split('_')
//           .map(capitalize)
//           .join(' '),
//     selected: packages[room] && packages[room].plan,
//     icon: roomsOptions[key] && roomsOptions[key].icon,
//   }));
//   const roomsDeliveryOptions = rooms.map(({ name: room, key, index, multipleOfSameType }) => ({
//     name: key,
//     value: room,
//     label: roomsOptions[key]
//       ? capitalize(`${roomsOptions[key].label}${multipleOfSameType ? ` ${index + 1}` : ''}`)
//       : room
//           .split('_')
//           .map(capitalize)
//           .join(' '),
//     selected: packages[room] && packages[room].term,
//     icon: roomsOptions[key] && roomsOptions[key].icon,
//   }));
//
//   const packageInvalid = rooms.some(
//     ({ name: room }) => !packages[room] || (packages[room] && !packages[room].plan),
//   );
//   const deliveryInvalid = rooms.some(
//     ({ name: room }) => !packages[room] || (packages[room] && !packages[room].term),
//   );
//   const addressInvalid =
//     Object.values(address).some(value => !(value || '').trim().length) ||
//     !isPhoneValid(address.phone) ||
//     !isZipValid(address.postcode);
//
//   return {
//     roomsPackages: roomsPackagesOptions,
//     roomsDelivery: roomsDeliveryOptions,
//     packagesOptions: packagesOptions || [],
//     plansOptions: plansOptions || [],
//     prices,
//     values: { packages, address, rooms: roomsValues },
//     form: {
//       packageInvalid,
//       deliveryInvalid,
//       addressInvalid,
//     },
//   };
// };



// WEBPACK FOOTER //
// ./app/javascript/components/brief/store/selectors.js